/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=08098032&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=08098032&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08098032"]])

export default __exports__